import type { DataGridProps } from '@mui/x-data-grid'
import React from 'react'

const MuiDataGrid = React.lazy(() => import('@mui/x-data-grid').then((module) => ({ default: module.DataGrid })))

const dataGridStyles = {
  '&.MuiDataGrid-root': { borderLeft: 'none', borderRight: 'none', borderBottom: 'none', borderRadius: 0 },
  '& .MuiDataGrid-columnHeadersInner': {
    '& .MuiDataGrid-columnHeader:last-child': {
      '& .MuiDataGrid-columnSeparator': { visibility: 'hidden' },
    },
  },
  '& .MuiDataGrid-cell': {
    alignItems: 'center',
    display: 'flex',
    minHeight: 36,
  },
}

interface Props extends DataGridProps {
  pageSize?: number
  initialState?: object
}

export const DataGrid = (props: Props) => {
  const density = props.density || 'compact'
  const disableRowSelectionOnClick =
    props.disableRowSelectionOnClick !== undefined ? props.disableRowSelectionOnClick : true
  const disableColumnMenu = props.disableColumnMenu !== undefined ? props.disableColumnMenu : true

  const cursorStyles = {
    ...(props.onRowClick ? { '& .MuiDataGrid-row:hover': { cursor: 'pointer' } } : {}),
    ...(props.onCellClick ? { '& .MuiDataGrid-cell:hover': { cursor: 'pointer' } } : {}),
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <MuiDataGrid
        {...props}
        sx={{ ...dataGridStyles, ...cursorStyles, ...props.sx }}
        autoHeight={props.autoHeight !== undefined ? props.autoHeight : true}
        density={density}
        disableRowSelectionOnClick={disableRowSelectionOnClick}
        disableColumnMenu={disableColumnMenu}
      />
    </div>
  )
}
